import { useEffect, useRef, useState } from 'react';
import { useDeleteCartMutation } from '../../../apis/cart';
import { getAppSource } from '../../../store/parentApi';

// Bundles and regular Prop Shop products share the same cart. Landing on either purchase
// flow's entry page clears any leftover lines from the other flow, so a cart never ends up
// mixing bundle and non-bundle items — the checkout summary can only render one or the other.
// While that clearing is in flight (mount only), the caller should treat the cart as still
// loading — otherwise the page briefly shows the stale, about-to-be-removed cart contents
// before they vanish, which misleads the user into thinking that's their actual cart.
const useEmptyCartOnMount = (cartData, isCartFetching) => {
  const [deleteCart] = useDeleteCartMutation();
  const hasRun = useRef(false);
  const [isEmptyingOnMount, setIsEmptyingOnMount] = useState(false);

  useEffect(() => {
    if (hasRun.current || !cartData) return;
    hasRun.current = true;

    if (cartData?.cartProducts?.length) {
      setIsEmptyingOnMount(true);
      deleteCart({
        productList: cartData.cartProducts.map((product) => ({
          id: product.item_id,
          _destroy: true,
          source: getAppSource(),
        })),
      });
    }
  }, [cartData]);

  // Clears once the invalidation-triggered refetch has settled on an actually-empty cart.
  useEffect(() => {
    if (isEmptyingOnMount && !cartData?.cartProducts?.length && !isCartFetching) {
      setIsEmptyingOnMount(false);
    }
  }, [isEmptyingOnMount, cartData, isCartFetching]);

  return isEmptyingOnMount;
};

export default useEmptyCartOnMount;
